import { TimePicker } from 'antd';
import { Dayjs } from 'dayjs';
import styled from 'styled-components';

const StyledWizrTimePicker = styled(TimePicker)`

&.ant-picker{
background-color: #f2f4f9 !important;
  width: 100% !important;
  border-radius:16px;
  height: 50px !important;
}

&.ant-picker-input{
  background-color: #f2f4f9 !important;
  width: 100% !important;
  border-radius:16px;
  height: 50px !important;
  }
  `;


interface WizrTimePickerProps {
  value?: Dayjs;
  onChange?: (date: Dayjs, dateString: string) => void;
  format?: string;
}

const WizrTimePicker = ({ value, onChange, format }: WizrTimePickerProps) => {
  const handleChange = (date: Dayjs, dateString: string | string[]) => {
    onChange?.(date, dateString as string);
  };

  return <StyledWizrTimePicker value={value} onChange={handleChange} format={format} />;
};

export default WizrTimePicker;
